<template>
    <div>
        <div v-if="cart" class="cart">
            <ul>
                <li v-for="(album, c) in cart.albums" :key="c">
                    <div class="cart-album-title">
                        <span>{{ album.album_title ? album.album_title : $t('no_name') }}</span>
                        <div class="cart-album-actions">
                            <!--<a href="#" @click.prevent="$router.push(i18nLink(`album/gallery/${getAlbumId(album)}`))" class="btn btn-light btn-icon-left mb-1 ml-3 text-uppercase">
                                <span class="material-icon icon-reply"/>
                                {{ $t('back_to_gallery') }}
                            </a>-->
                            <a href="#" @click.prevent="$router.push(i18nLink(`album/gallery/${getAlbumId(album)}${_.first(album.products).tag ? `/tag/${_.first(album.products).tag}` : ''}`))" class="btn btn-light btn-icon-left mb-1 ml-3 text-uppercase">
                                <span class="material-icon icon-undo"/>
                                {{ $t('back_to_gallery') }}
                            </a>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table v-if="!!album.products.length" class="table">
                            <thead>
                            <tr>
                                <th>{{ $t('product') }}</th>
                                <th>{{ $t('price') }}</th>
                                <th>{{ $t('shopping_cart.quantity') }}</th>
                                <th colspan="3">{{ $t('total') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(product, p) in album.products" :key="p" :class="{'cart-bulk-price': product.next_bulk_price}">
                                <td>
                                    <a href="#" class="cart-product"
                                       @click.prevent="edit(getAlbumId(album), product.uuid, product.products ? product : false, product.tag)">
                                        <!--<span class="cart-product-img" v-if="product.thumb_image"
                                              :style="`background-image: url(${product.thumb_image})`"></span>-->
                                        <img v-if="product.thumb_image" class="cart-product-img" :src="product.thumb_image" alt="">
                                        <span v-else class="cart-product-no-img"></span>
                                        <span class="cart-product-info">
                                            <span class="cart-product-title">
                                                {{ product.name }}
                                            </span>
                                            <span class="cart-product-description">
                                                <template v-if="product.photos_quantity">{{ $tc('n_photos_2', product.photos_quantity, {amount_total_photos: product.photos_quantity}) }}</template><template v-if="product.products">{{ $tc('n_products', product.products.length, {amount: product.products.length}) }}</template><template v-if="product.snippet">, {{ product.snippet }}</template><template v-if="product.product_variant_name">, {{ product.product_variant_name }}</template>
                                            </span>
                                            <br>
                                        </span>
                                    </a>
                                    <!--<a href="#" v-if="product.next_bulk_price" class="cart-bulk-price-alert" @click.prevent="edit(getAlbumId(album), product.uuid, product.products ? product : false, product.tag)">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 210 210">
                                            <path d="M601,233A105,105,0,1,0,706,338,105,105,0,0,0,601,233Zm0,189.68A84.68,84.68,0,1,1,685.68,338,84.63,84.63,0,0,1,601,422.68Z"
                                                  transform="translate(-496 -233)"/>
                                            <path d="M601,279.57a17.78,17.78,0,1,1-17.78,17.78A17.78,17.78,0,0,1,601,279.57Z"
                                                  transform="translate(-496 -233)"/>
                                            <path d="M624.71,387.11a5.08,5.08,0,0,1-5.08,5.08H582.37a5.08,5.08,0,0,1-5.08-5.08V377a5.08,5.08,0,0,1,5.08-5.08h5.08v-27.1h-5.08a5.08,5.08,0,0,1-5.08-5.08V329.53a5.08,5.08,0,0,1,5.08-5.08h27.1a5.08,5.08,0,0,1,5.08,5.08v42.34h5.08a5.08,5.08,0,0,1,5.08,5.08v10.16Z"
                                                  transform="translate(-496 -233)"/>
                                        </svg>
                                        <span>{{ $t('bulk_price_alert', {quantity: product.next_bulk_price.quantity, nextPrice: $options.filters.currency(product.next_bulk_price.price), price: $options.filters.currency(product.price)}) }}</span>
                                    </a>-->
                                </td>
                                <td>{{ product.price | currency }}</td>
                                <td>
                                    <counter v-if="product.slug !== 'digital'" :index="p" :parent-index="c" :quantity="product.quantity"
                                             @reload-product-total="reloadProductTotal($event)"
                                             action="SET_PRODUCT_QUANTITY"/>
                                </td>
                                <td :id="`total-${c}-${p}`">{{ product.total | currency }}</td>
                                <td class="cart-action">
                                    <a href="#" class="btn btn-icon-left btn-shadow btn-primary text-uppercase" @click.prevent="edit(getAlbumId(album), product.uuid, product.products ? product : false, product.tag)">
                                        <span class="material-icon icon-create"/>
                                        {{ $t('edit') }}
                                    </a>
                                </td>
                                <td class="cart-action pl-0">
                                    <button class="btn btn-light" @click.prevent="remove(p, c)">
                                        <span class="material-icon icon-delete"/>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </li>
            </ul>
        </div>
        <div v-else class="alert alert-info">{{ $t('shopping_cart.empty_card') }}</div>
    </div>
</template>

<style lang="scss">
    .cart {
        margin: 0;
        padding: 0;
        list-style: none;

        &-album-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 35px;
            font-size: 2.1rem;
            white-space: nowrap;
            overflow: hidden;
            color: var(--text-color);

            > span {
                max-width: 500px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            &--small {
                font-size: 1.25rem;
            }

            .material-icon {
                margin-right: 10px;
            }
        }

        &-product {
            display: flex;
            align-items: flex-start;

            &,
            &:hover,
            &:focus {
                color: inherit;
                text-decoration: none;
            }

            &-no-img,
            &-img {
                min-width: 120px;
                max-width: 120px;
                height: auto;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: 50% 50%;
                background-color: var(--bg-color);
            }

            &-no-img {
                height: 120px;
                background: 50% 50% no-repeat;
                background-size: cover;
                background-image: url('../assets/no-preview-large.jpg');
            }

            &-info {
                display: flex;
                flex-direction: column;
                justify-content: center;
                flex-grow: 1;
                padding-left: 15px;
            }

            &-title {
                font-weight: 500;
                color: var(--text-color);
            }

            &-description {
                font-size: .87rem;
                color: var(--text-secondary-color);
            }

            &-quantity {

            }
        }

        &-action {
            width: 70px;
            text-align: center;
        }

        &-bulk-price {
            position: relative;

            &-alert {
                position: absolute;
                min-width: 550px;
                max-width: 720px;
                padding: 20px 30px;
                display: flex;
                align-items: center;
                left: 50%;
                transform: translate(-50%, -50%);
                background-color: #d9edf5;

                &,
                &:hover,
                &:focus {
                    color: #0083b9;
                    text-decoration: none;
                }

                > svg {
                    margin-right: 15px;
                    min-width: 30px;
                    max-width: 30px;
                    height: 30px;
                    fill: #0083b9;
                }

                > span {
                    font-size: .93rem;
                }
            }
        }

        > ul {
            margin: 0;
            padding: 0;
            list-style: none;
        }

        .table {
            color: var(--text-color);

            > tbody {

                > tr {

                    > td {
                        border-top-color: var(--bg-secondary-color-dark);
                    }
                }
            }
        }

        table {
            margin-bottom: 60px !important;
            font-size: 1rem;

            > thead {

                tr {

                    th {
                        font-size: 1.25rem;
                        font-weight: 500;
                        border: none;

                        &:first-child {
                            padding-left: 0;
                        }
                    }
                }
            }

            > tbody {

                > tr {

                    > td {
                        padding-top: 15px;
                        padding-bottom: 15px;
                        vertical-align: middle;

                        &:nth-child(1) {
                            padding-left: 0;
                            min-width: 350px;
                        }

                        &:nth-child(2) {
                            min-width: 120px;
                        }

                        &:nth-child(4) {
                            min-width: 140px;
                        }
                    }
                }
            }
        }
    }
</style>

<script>
  import Counter from './Counter.vue';

  import cart from 'src/mixins/cartComponent';

  export default {
    mixins: [cart],
    components: {
      Counter,
    },
  };
</script>
